export const DashboardPage = () => {
  return <h1>Я страница дашборда</h1>
}
